import { Spinner } from 'react-bootstrap';

export default function LoadingSpinnerInline() {
    return (
        <Spinner animation='border' className='loading-spinner-inline'/>
    );
}
